import { axiosPost, axiosGet, axiosDelete, DOMAIN } from "@/network/request.js";
import { dataURLtoBlob, dataURLtoFile } from "@/common/utils/image.js";
import Qs from 'qs';
import Axios from 'axios';
import { getStorage, setStorage } from "@/common/utils/storage.js"
import store from "@/store"
 const username = '';
 const userId = '';

/**
 * @description 获取项目体系
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceSystemApi = async function (params = {}) {
    try {
        if (!params?.username) {
            username && (params.username = username);
        }
        if (!params?.userId) {
            userId && (params.userId = userId);
        }
        const res = await axiosGet('/devops/project/system?action=list', params);
        return res;
    } catch (error) {
        throw new Error(error)
    }
}

/**
 * @description 获取人员
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceAllUserListApi = async function (params = {}) {
    try {
        if (!params?.username) {
            username && (params.username = username);
        }
        if (!params?.userId) {
            userId && (params.userId = userId);
        }
        const res = await axiosGet('/devops/project/user?action=list', params);
        return res;
    } catch (error) {
        throw new Error(error)
    }
}

/**
 * @description 获取状态
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceAllStatusListApi = async function (params = {}) {
    try {
        if (!params?.username) {
            username && (params.username = username);
        }
        if (!params?.userId) {
            userId && (params.userId = userId);
        }
        const res = await axiosGet('/devops/project/status?action=list', params);
        return res;
    } catch (error) {
        throw new Error(error)
    }
}


/**
 * @description 查询展示页面布局权限
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceMenuListListApi = async function (params = {}) {
    try {
        if (!params?.username) {
            username && (params.username = username);
        }
        if (!params?.userId) {
            userId && (params.userId = userId);
        }
        const res = await axiosGet('/devops/menu?action=list', params);
        if(res.data.menulList){
        let menuList = res.data.menulList;
            for(let i = 0;i < menuList.length;i++){
                // 将任务池添加到第一个
                let newChildren = [];
                let newPath={}
                let flag=false
                if(menuList[i].code==="navi_task_page"){
                    newChildren=menuList[i].children
                    flag=  newChildren.some(item=>item?.code==='tab_task_list_devChecklist')
                    if(flag){
                        newChildren= newChildren.filter(item=>item.code!=="tab_task_list_devChecklist")
                        newPath=menuList[i].children.filter(item=>item.code==="tab_task_list_devChecklist")[0]
                        newChildren.unshift(newPath)
                        menuList[i].children= newChildren
                    }
                }
                menuList[i]['index'] = i;
                for(let j = 0;j < menuList[i].children.length;j++){
                menuList[i].children[j]['index'] =  i +''+ (j+1);
                }
            }
            store.dispatch('setMenuList', menuList);
        }
        return res;
    } catch (error) {
        throw new Error(error)
    }
}

/**
 * @description 查询工单类型接口
 * @param {} params
 * @returns
 */
export const getDevOpsSpaceWorkOrderConfigApi = async function (params = {}) {
    try {
        if (!params?.username) {
            username && (params.username = username);
        }
        if (!params?.userId) {
            userId && (params.userId = userId);
        }
        if(!params.type){
            params.type = 'all';
        }
        const res = await axiosGet('/devops/work_order?action=get&project_name=config', params);
        return res;
    } catch (error) {
        throw new Error(error)
    }
}


